export async function trackRequest<T>(background: boolean, run: () => Promise<T>): Promise<T> {
  if (background) return run();
  active += 1;
  try {
    return await run();
  } finally {
    active -= 1;
    for (const listener of [...listeners]) listener();
  }
}

export function whenForegroundQuiet(
  quietMs = FOREGROUND_QUIET_MS,
  signal?: AbortSignal,
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(signal.reason);
      return;
    }
    let timer: ReturnType<typeof setTimeout> | null = null;
    const check = () => {
      if (timer !== null) clearTimeout(timer);
      timer = null;
      if (active > 0) return;
      timer = setTimeout(() => {
        if (active > 0) return;
        listeners.delete(check);
        signal?.removeEventListener("abort", stop);
        resolve();
      }, quietMs);
    };
    signal?.addEventListener("abort", stop, { once: true });
    listeners.add(check);
    check();

    function stop() {
      if (timer !== null) clearTimeout(timer);
      listeners.delete(check);
      reject(signal?.reason);
    }
  });
}

const listeners = new Set<() => void>();
let active = 0;

const FOREGROUND_QUIET_MS = 400;
